/**
 * 时间轴横向缩放：与 TimelineEditor 原逻辑一致（约 0.8x～2x）
 */
export function calcTimelineZoomScale(zoomLevel: number): number {
    return 0.8 + (zoomLevel / 100) * 1.2;
}
